import { getCookies, setCookies } from '@/util/cookies'

// Update with IB
export class PopupBannerModel {
  constructor({
    key,
    component,
    displayPage,
    excludeCountry = null,
    country = null,
    priority = null,
    cookie = null,
    salesCompany = null,
    props = null,
  }) {
    // String
    this.key = key
    // Component
    this.component = component
    // Number
    this.displayPage = displayPage
    // Array<Number>?
    // null = not taking this condition
    this.excludeCountry = excludeCountry ?? null
    // Array<Number>?
    // null = not taking this condition
    this.country = country ?? null
    // String?
    // null = not taking this condition
    this.salesCompany = salesCompany ?? null
    // Number?
    this.priority = priority ?? null
    // { key: String, duration: Number }?
    // only for PopupBannerPeriodical (ib portal)
    this.cookie = cookie ?? null
    this.props = props ?? null
  }

  filterFn(countryCode, displayPage, salesCompany) {
    let isShow =
      // Check excludeCountry
      (this.excludeCountry === null || (this.excludeCountry !== null && !this.excludeCountry.includes(countryCode))) &&
      // Check includeCountry
      (this.country === null || (this.country !== null && this.country.includes(countryCode))) &&
      // Check salesCompany
      (this.salesCompany === null || (this.salesCompany !== null && this.salesCompany === salesCompany)) &&
      // Check displayPage
      this.displayPage === displayPage

    // For periodically Banner (with cookies)
    if (isShow && this.cookie) {
      if (!getCookies(this.cookie.key)) {
        setCookies(this.cookie.key, true, this.cookie.duration)
      } else {
        isShow = false
      }
    }
    return isShow
  }
}

// Standardize with BE (BannerDisplayPageEnum filter by [1])
export const popupBannerDisplayPageEnum = Object.freeze({ home: 1, download: 2, deposit: 4 })

// popupBannerDisplayPageEnum?
export const getPopupBannerDisplayPageEnumFromRoutePath = routePath => {
  switch (routePath) {
    case '/home':
      return popupBannerDisplayPageEnum.home
    case '/downloads':
      return popupBannerDisplayPageEnum.download
    case '/depositFunds':
      return popupBannerDisplayPageEnum.deposit
    case '/deposit':
      return popupBannerDisplayPageEnum.deposit
    default:
      return null
  }
}

// Layout
export const popupBannerDisplayPageWhiteList = ['/home', '/downloads', '/depositFunds']
